import { createSlice } from "@reduxjs/toolkit";
import {
  addPreset,
  deletePart,
  deletePreset,
  fetchExtraPartRequests,
  fetchPresetById,
  fetchMaintenance,
  fetchMaintenanceData,
  fetchPartById,
  fetchParts,
  fetchPresets,
  generateMaintenanceTask,
  acceptExtraPartRequest,
  updatePart,
  updatePreset,
  fetchAnalytics,
  fetchSupplierMaintenance,
} from "../actions/servicePresetsActions";

const initialState = {
  isLoading: false,
  isLoading2: false,
  serviceList: [],
  analyticsData: {},
  selectedService: null,
  maintananceList: [],
  supplierMaintananceList: [],
  maintananceData: {},
  partsLoading: false,
  partsData: [],
  selectedPartDetail: null,
  requestedPartsLoading: false,
  requestedPartsData: [],
};

export const authSlice = createSlice({
  name: "service-presets",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch-maintenance
    builder.addCase(fetchMaintenance.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMaintenance.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.maintananceList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchMaintenance.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-supplier-maintenance
    builder.addCase(fetchSupplierMaintenance.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSupplierMaintenance.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.supplierMaintananceList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchSupplierMaintenance.rejected, (state, action) => {
      state.isLoading = false;
    });

    // generateMaintenanceTask
    builder.addCase(generateMaintenanceTask.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(generateMaintenanceTask.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(generateMaintenanceTask.rejected, (state, action) => {
      state.isLoading2 = false;
    });


    // maintenance-data
    builder.addCase(fetchMaintenanceData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMaintenanceData.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.maintananceData = data || {};
      state.isLoading = false;
    });
    builder.addCase(fetchMaintenanceData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-analytics
    builder.addCase(fetchAnalytics.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAnalytics.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.analyticsData = data || {};
      state.isLoading = false;
    });
    builder.addCase(fetchAnalytics.rejected, (state, action) => {
      state.isLoading = false;
    });


    // fetch-presets
    builder.addCase(fetchPresets.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPresets.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.serviceList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchPresets.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-preset-by-id
    builder.addCase(fetchPresetById.pending, (state) => {});
    builder.addCase(fetchPresetById.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.selectedService = data || null;
    });
    builder.addCase(fetchPresetById.rejected, (state) => {});
    // delete-presets
    builder.addCase(deletePreset.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deletePreset.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deletePreset.rejected, (state, action) => {
      state.isLoading = false;
    });
    // add-presets
    builder.addCase(addPreset.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addPreset.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addPreset.rejected, (state, action) => {
      state.isLoading = false;
    });
    // delete-part
    builder.addCase(deletePart.pending, (state) => {
      state.partsLoading = true;
    });
    builder.addCase(deletePart.fulfilled, (state) => {
      state.partsLoading = false;
    });
    builder.addCase(deletePart.rejected, (state) => {
      state.partsLoading = false;
    });
    // update-part
    builder.addCase(updatePart.pending, (state) => {
      state.partsLoading = true;
    });
    builder.addCase(updatePart.fulfilled, (state) => {
      state.partsLoading = false;
    });
    builder.addCase(updatePart.rejected, (state) => {
      state.partsLoading = false;
    });
    // update-presets
    builder.addCase(updatePreset.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updatePreset.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updatePreset.rejected, (state, action) => {
      state.isLoading = false;
    });

    //parts management 
    builder.addCase(fetchParts.pending, (state) => {
      state.partsLoading = true;
    })
    builder.addCase(fetchParts.fulfilled, (state, action) => {
      const payloadData = action?.payload?.data;

      state.partsLoading = false;
      state.partsData = Array.isArray(payloadData)
        ? payloadData
        : Array.isArray(payloadData?.data)
          ? payloadData.data
          : [];
    })
    builder.addCase(fetchParts.rejected, (state) => {
      state.partsLoading = false;
    });
    builder.addCase(fetchPartById.pending, (state) => {
      state.partsLoading = true;
    });
    builder.addCase(fetchPartById.fulfilled, (state, action) => {
      state.partsLoading = false;
      state.selectedPartDetail = action?.payload?.data || null;
    });
    builder.addCase(fetchPartById.rejected, (state) => {
      state.partsLoading = false;
    });

    builder.addCase(fetchExtraPartRequests.pending, (state) => {
      state.requestedPartsLoading = true;
    });
    builder.addCase(fetchExtraPartRequests.fulfilled, (state, action) => {
      state.requestedPartsLoading = false;
      state.requestedPartsData = Array.isArray(action?.payload?.data)
        ? action.payload.data
        : [];
    });
    builder.addCase(fetchExtraPartRequests.rejected, (state) => {
      state.requestedPartsLoading = false;
    });

    builder.addCase(acceptExtraPartRequest.pending, (state) => {
      state.requestedPartsLoading = true;
    });
    builder.addCase(acceptExtraPartRequest.fulfilled, (state) => {
      state.requestedPartsLoading = false;
    });
    builder.addCase(acceptExtraPartRequest.rejected, (state) => {
      state.requestedPartsLoading = false;
    });
},
});
export default authSlice.reducer;
